"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_soho(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a61ed307-cf4b-4fd6-ae92-acf0cd5c1bcc",
    x1: 91.27,
    y1: 120.82,
    x2: 104.79,
    y2: 134.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "soho-hi"), /*#__PURE__*/React.createElement("g", {
    id: "100f3179-7268-454d-aa54-687a7829b46e",
    "data-name": "soho-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "686eb410-aae5-4d25-8808-163245e6abd2",
    "data-name": "Cloud_upload_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aece92bd-861f-48cb-bafa-f9cd8e50e1fe",
    "data-name": "Calls_Contacts_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6512b9e2-0fd8-4fe5-9226-2cfba4f66610",
    "data-name": "PayG_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "df1ff5e2-8e6a-48f2-8168-d455e5a13bcb",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a0b9aac5-535a-4fa5-98a6-fde31d286f4b",
    "data-name": "My_Vodafone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "37b1a2c0-c386-431a-8b08-a9a591bf204a",
    "data-name": "Settings_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f2bf6c73-1b95-4c01-b0dd-c2ebc9d63c86",
    "data-name": "User_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4af99994-ccf4-4597-ac4d-6511d969ccf1",
    "data-name": "Video_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0cf678c9-9470-4f14-9aee-8066c159c03b",
    "data-name": "Tutorials_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "af7d3189-f669-4005-be05-504413cba1a2",
    "data-name": "Community_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e9d2c8bb-6662-4cb2-a5a8-ca7cf2ec9f3a",
    "data-name": "Entertainment_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "37759e39-1383-4cd0-825e-1ff94a96b646",
    "data-name": "Insurance_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ee6d00f7-3409-4381-aa7e-9906578fc49a",
    "data-name": "Photos_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "903e1d94-bd2b-43b8-bb51-d2542f14da87",
    "data-name": "Pie_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d6431fcf-c0c7-4481-8413-8406da9195e0",
    "data-name": "Shopping_trolley_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "118acb82-1e40-40c4-8581-700a531ec96f",
    "data-name": "Business_phone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9ffe4556-6ef4-4631-88b2-3a1bf8f9cc0c",
    "data-name": "Bundles_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8597159e-793a-4660-a149-f8fbeec6eaf8",
    "data-name": "Customer_care_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "971548fe-141d-4f2f-8a6b-8a61fb895ed0",
    "data-name": "Minutes_sms_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2a116566-8d1a-42c0-a74b-7fc7119600f5",
    "data-name": "Bar_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03c3281e-c19c-44c3-a0fa-0d143e8baa72",
    "data-name": "Line_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cf19ae7b-91c4-4eb3-851b-79a3ff863580",
    "data-name": "Blog_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a9c69e0b-ac8c-4191-bf5f-241b2190f41e",
    "data-name": "SoHo_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60,167.92l9.78-19.53A8,8,0,0,1,76.94,144h38.17a8,8,0,0,1,7.16,4.43L132,167.92",
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 112.56,
    x2: 96,
    y2: 168,
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60,167.92l9.78-19.53A8,8,0,0,1,76.94,144h38.17a8,8,0,0,1,7.16,4.43L132,167.92",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 112.56,
    x2: 96,
    y2: 168,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 166,
    width: 8,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.94,146a4,4,0,0,0-3.58,2.21l-9.78,19.53-6.35-3.18-.8,1.6,7.15,3.58,9.78-19.53A4,4,0,0,1,76.94,148H92v-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.41,167.7l-9.72-19.52a4,4,0,0,0-3.58-2.22H100v2h15.11a4,4,0,0,1,3.58,2.22l9.72,19.52,7.16-3.57-.8-1.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44,76V99.92a8,8,0,0,0,8,8H66.83",
    fill: "none",
    stroke: "#ebebeb",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,76V99.92a8,8,0,0,1-8,8H125.19",
    fill: "none",
    stroke: "#ebebeb",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,76V99.92a8,8,0,0,0,8,8H66.83",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,76V99.92a8,8,0,0,1-8,8H125.19",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.83,109.92H52a12,12,0,0,1-12-12v2a12,12,0,0,0,12,12H66.83a4,4,0,0,0,3.86-5A4,4,0,0,1,66.83,109.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,109.92H125.19a4,4,0,0,1-3.86-3,4,4,0,0,0,3.86,5H140a12,12,0,0,0,12-12v-2A12,12,0,0,1,140,109.92Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80,15.83h32a16,16,0,0,1,16,16v68a0,0,0,0,1,0,0H64a0,0,0,0,1,0,0v-68a16,16,0,0,1,16-16Z",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 96,
    width: 88,
    height: 24,
    rx: 8,
    ry: 8,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 96,
    width: 88,
    height: 24,
    rx: 8,
    ry: 8,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,118H60a8,8,0,0,1-8-8v2a8,8,0,0,0,8,8h72a8,8,0,0,0,8-8v-2A8,8,0,0,1,132,118Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.01,
    cy: 167.92,
    r: 8,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,173.92a8,8,0,0,1-7.93-7,8,8,0,1,0,15.86,0A8,8,0,0,1,60,173.92Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 167.92,
    r: 8,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,173.92a8,8,0,0,1-7.93-7,8,8,0,1,0,15.86,0A8,8,0,0,1,96,173.92Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 167.92,
    r: 8,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 167.92,
    r: 8,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,173.92a8,8,0,0,1-7.93-7,8,8,0,1,0,15.86,0A8,8,0,0,1,132,173.92Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.05 139.08 92.02 131.05 92.02 120.06 100.02 120.08 100.02 130.57 100.05 139.08",
    opacity: 0.2,
    fill: "url(#a61ed307-cf4b-4fd6-ae92-acf0cd5c1bcc)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }))))))))))))))))))))))))));
}

var _default = ic_soho;
exports.default = _default;